import { Icon } from "./Icon";
import type { DashboardLogo, DashboardSwitcherItem } from "./types";

function renderLogo(logo: DashboardLogo | undefined, fallbackAlt: string) {
  if (!logo) return null;
  if (typeof logo === "object" && "src" in logo) {
    return <img src={logo.src} alt={logo.alt || fallbackAlt} />;
  }
  return logo;
}

export type AppSwitcherProps = {
  items?: DashboardSwitcherItem[];
  mainDashboardRoute: string;
  onNavigate: (route: string) => void;
};

export function AppSwitcher({ items = [], mainDashboardRoute, onNavigate }: AppSwitcherProps) {
  const visibleItems = items.filter(
    (item) => item.visible !== false && item.id !== "main-dashboard" && item.route !== mainDashboardRoute,
  );

  if (visibleItems.length === 0) return null;

  return (
    <div className="in-app-switcher" role="menu" aria-label="Switch apps">
      {visibleItems.map((item) => (
        <button
          key={item.id}
          type="button"
          className="in-app-switcher-item"
          onClick={() => onNavigate(item.route)}
          role="menuitem"
          aria-label={item.label}
          title={item.label}
        >
          <span className="in-app-switcher-icon">
            {renderLogo(item.logo, "") || (item.logoUrl ? <img src={item.logoUrl} alt="" /> : <Icon name={item.icon || "apps"} />)}
          </span>
        </button>
      ))}
    </div>
  );
}
